import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ButtonGroup from "@mui/material/ButtonGroup";
import { map, find } from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import SelectionList from "../../Components/List/SelectionList";
import {
  getTaskInfo,
  getTaskAssets,
  updateTask,
  checkTaskAttemptedOrNot,
} from "./Services";
import { getFormatedDate, getFormatedTime } from "../../Js/TimeAndDate";
import { taskSliceActions } from "../../Store/Slices/TaskSlice";
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import { userLogs, durationCalculate } from "../../Js/Common";
import Confirmation from "../../Components/Modal/Confirmation";

let starttime, target;

const TaskInfo = (props) => {
  const classes = useStyles();
  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  let { id } = useParams();

  // State
  const [taskInfo, setTaskInfo] = useState(null);
  const [assetList, setAssetList] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [alertFlag, setAlertFlag] = useState(false);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  // React logic hooks
  useEffect(() => {
    fetchTaskInfo();
    dispatch(taskSliceActions.resetState());
    dispatch(taskSliceActions.setDurationFlag(false));
    starttime = Date.now();
    // } else {
    //   logFunction("view", durationCalculate(0, startTime));
    //   setStartTime(0);
    // }
    return () => {
      logFunction("view", durationCalculate(0, starttime), target);
    };
  }, []);

  // To drop logs
  const logFunction = async (action, duration, target = taskInfo.uid) => {
    let logResponse = await userLogs({
      actor: userInfo.uid,
      verb: "task",
      target: target,
      outcome: {
        value: "",
        action: action,
        duration: duration,
      },
      site_uuid: userInfo.site_uuid,
    });
  };

  // Fetch Task Information
  const fetchTaskInfo = async () => {
    let taskInfoData = await getTaskInfo(id, userInfo.site_uuid);
    setTaskInfo(taskInfoData.data[0]);
    target = taskInfoData.data[0]["uid"];
    if (
      taskInfoData.data[0]["tasktype"] == "assets" ||
      taskInfoData.data[0]["tasktype"] == "library"
    ) {
      let assets = await getTaskAssets(
        taskInfoData.data[0].data1.exersices,
        userInfo.site_uuid
      );
      let sortedData = taskInfoData.data[0].data1.exersices.map((val) => {
        let foundObj = find(assets.data, { asset_uid: val });
        return foundObj;
      });
      setAssetList(sortedData);
    }
  };

  // Assign task directly from this page
  const assignTask = () => {
    if (taskInfo.tasktype.toUpperCase() == "ASSETS") {
      dispatch(
        assignmentSliceActions.addTask({
          id: taskInfo.uid,
          name: taskInfo.title,
          estimated_time: taskInfo.estimated_time,
          assets: taskInfo.data1.exersices,
        })
      );
      navigation("/Assign/Create/assets");
    }
    if (taskInfo.tasktype.toUpperCase() == "MEDIA") {
      dispatch(
        assignmentSliceActions.addTask({
          id: taskInfo.uid,
          name: taskInfo.title,
          estimated_time: taskInfo.estimated_time,
        })
      );
      dispatch(assignmentSliceActions.setDefaultsAttempts("1"));
      navigation("/Assign/Create/media");
    }
    if (taskInfo.tasktype.toUpperCase() == "LIBRARY") {
      dispatch(
        assignmentSliceActions.addTask({
          id: taskInfo.uid,
          name: taskInfo.title,
          estimated_time: taskInfo.estimated_time,
          assets: taskInfo.data1.exersices,
        })
      );
      dispatch(assignmentSliceActions.setDefaultsAttempts("1"));
      navigation("/Assign/Create/library");
    }
  };

  // Delete Action
  const deleteConfirm = async () => {
    let response = await updateTask(
      {
        is_deleted: true,
      },
      taskInfo.uid,
      userInfo.site_uuid
    );

    if (response.status == 200) {
      setConfirmModal(false);
      logFunction("delete", 0);
      navigation("/Task");
    }
  };

  // Edit Action
  const edit = async () => {
    let anyAttempt = await checkTaskAttemptedOrNot(
      taskInfo.uid,
      userInfo.site_uuid
    );
    if (anyAttempt.data && anyAttempt.data.length > 0) {
      setAlertFlag(true);
      return false;
    }
    navigation(`/Task/EditDetail/${taskInfo.uid}/${taskInfo.tasktype}`);
  };

  const goToView = (id) => {
    navigation(`/Task/AssetView/${id}`);
  };

  return (
    <Grid container>
      <Grid item xs={12} sx={{}}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "space-around",
            pt: 2,
            pl: 3,
            pr: 7,
            backgroundColor: "#89ff6cff",
            overflow: "auto",
            width: "95%",
            marginLeft: 4,
            borderRadius: 5,
          }}
        >
          <Grid container xs={9} sx={{}}>
            {taskInfo && (
              <Box>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Name: </b> {taskInfo.title ? taskInfo.title : ""}
                </Typography>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Description:</b>{" "}
                  {taskInfo.description ? taskInfo.description : ""}
                </Typography>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Created On:</b>{" "}
                  {taskInfo.createdAt
                    ? getFormatedDate(taskInfo.createdAt)
                    : ""}
                </Typography>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Tag:</b> {taskInfo.tags ? taskInfo.tags.tags : ""}
                </Typography>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Type:</b>{" "}
                  {taskInfo.tasktype ? taskInfo.tasktype.toUpperCase() : ""}
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid container xs={3} sx={{ justifyContent: "right" }}>
            <Box
              sx={{
                display: "flex",
                "& > *": {
                  m: 1,
                  pl: 5,
                },
              }}
            >
              <Typography
                color="primary.main"
                sx={{
                  lineHeight: 2,
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                {taskInfo && taskInfo.estimated_time && (
                  <b>
                    {`${getFormatedTime(
                      taskInfo.estimated_time,
                      "HH:mm:ss"
                    )} Hrs`}
                  </b>
                )}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                "& > *": {
                  my: 3,
                  mt: 10,
                },
              }}
            >
              <ButtonGroup
                variant="text"
                sx={{ backgroundColor: "#FFFFFF", borderRadius: 15 }}
              >
                <Button sx={{ px: 2 }} onClick={edit}>
                  <BorderColorOutlinedIcon
                    sx={{
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  />
                </Button>
                <Button sx={{ px: 2 }} onClick={() => setConfirmModal(true)}>
                  <DeleteOutlineIcon
                    sx={{
                      color: "#c40000",
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  />
                </Button>
              </ButtonGroup>
            </Box>
          </Grid>
        </Grid>
        <Grid sx={{ pt: 3, pl: 3, pr: 7 }}>
          <Grid container xs={12} justifyContent="end">
            <Button
              variant="contained"
              size="small"
              sx={{
                px: 4,
                "@media (min-width: 1636px)": {
                  fontSize: "1.2rem",
                },
              }}
              onClick={assignTask}
            >
              Add Task
            </Button>
          </Grid>
          <Box
             
            sx={{
              height: "50vh",
              overflow: "auto",
              "@media (min-width: 1636px)": { height: "60vh" },
            }}
          >
            <Typography
              color="primary.main"
              sx={{
                pl: 3,
                "@media (min-width: 1636px)": {
                  fontSize: "1.4rem",
                },
              }}
            >
              <b>Assets</b>
            </Typography>
            {taskInfo &&
              (taskInfo.tasktype.toUpperCase() == "ASSETS" ||
                taskInfo.tasktype.toUpperCase() == "LIBRARY") &&
              assetList && (
                <>
                  {assetList.map((val, index) => {
                    return (
                      <div key={`${index}_assets`}>
                        <SelectionList
                          title={`${index + 1}. ${val.asset_name}`}
                          viewOnly={true}
                          viewaction={
                            taskInfo.tasktype.toUpperCase() == "ASSETS"
                              ? true
                              : false
                          }
                          view={() => {
                            goToView(val.asset_uid);
                          }}
                        ></SelectionList>
                      </div>
                    );
                  })}
                </>
              )}
            {taskInfo && taskInfo.tasktype.toUpperCase() == "MEDIA" && (
              <div key={`mediaTypeList`}>
                <SelectionList
                  title={`${taskInfo.data1["media"][0][
                    "mediaType"
                  ].toUpperCase()} File`}
                  viewOnly={true}
                ></SelectionList>
              </div>
            )}
          </Box>
        </Grid>
        <Confirmation
          image="delete"
          primaryText="Delete task"
          secondaryText="Do you want to delete this task ?"
          visible={confirmModal}
          positiveClick={deleteConfirm}
          negativeClick={() => {
            setConfirmModal(false);
          }}
          toggleModal={(flag) => setConfirmModal(flag)}
        ></Confirmation>
        <Confirmation
          image="error"
          primaryText="You can't edit this task!"
          secondaryText="Learners already attempted this task."
          visible={alertFlag}
          alert={true}
          toggleModal={(flag) => setAlertFlag(flag)}
          timeout={4500}
        ></Confirmation>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default TaskInfo;
